import { createFileRoute, redirect } from '@tanstack/react-router';

import { legacySettingsSearch, validateLegacyTeamSearch } from '@/pages/settings/settings-tabs';

/**
 * The standalone Trust Center is gone (Appendix A §9 cut list) — the
 * governance timeline is Team settings › Trust Center now. Old links redirect.
 */
export const Route = createFileRoute('/trust-center')({
  validateSearch: validateLegacyTeamSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/settings', search: legacySettingsSearch('trust-center', search) });
  },
});
